/* eslint-disable */
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import useStore from "../store/store";
import { all_routes } from "../Router/all_routes";
import requests from "../services/httpService";

export const useLoginSubmit = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const setUser = useStore((state) => state.setUser);

  const handleLoginSubmit = async (email, password) => {
    setLoading(true);
    setError("");
    if (!email || !password) {
      setError("Please fill in all fields");
      setLoading(false);
      return;
    }

    try {
      const response = await requests.post("/api/auth/login", {
        email,
        password,
      });

      if (response) {
        console.log("🚀 ~ handleLoginSubmit ~ response:", response)
        // Store user data in Zustand store
        setUser({
          id: response._id,
          name: response.name,
          email: response.email,
          phone: response.phone,
          role: response.role,
          permissions: response.permissions,
          franchiseId: response.franchiseId,
          storeId: response.storeId,
          token: response.token,
        });

        // Set default auth header
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.token}`;

        // Redirect to dashboard or intended route
        const redirectPath =
          location.state?.from?.pathname || all_routes.newdashboard;
        navigate(redirectPath, { replace: true });
      }
    } catch (err) {
      setError(err?.response?.message || "An error occurred during login");
    } finally {
      setLoading(false);
    }
  };

  return { error, loading, handleLoginSubmit };
};
